export default __webpack_public_path__ + "static/media/F0005.0e9b3554.png";